import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors } from '@/styles'

const SidebarLinkItem = styled.a`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  text-decoration: none;
  color: ${({ hasEssentialsPlan }) =>
    hasEssentialsPlan ? colors.grey64 : colors.regular};
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  padding: 15px 4px;
  border-radius: 6px;
  cursor: pointer;

  > span {
    color: ${colors.link};
    margin-left: auto;
  }
`

const LeftIconContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-right: 15px;
  bottom: 8.33%;
`

const SidebarLinkMobile = ({
  id,
  leftIcon,
  title,
  target = '_blank',
  href,
  hasEssentialsPlan,
  onClick,
  children
}) => {
  const { t } = useTranslation()
  const internalLink = !onClick && !href.startsWith('http')

  const LinkComponent = props => (
    <SidebarLinkItem
      id={id}
      target={target}
      as={onClick ? 'button' : 'a'}
      onClick={onClick}
      hasEssentialsPlan={hasEssentialsPlan}
      {...props}
    >
      {leftIcon ? <LeftIconContainer>{leftIcon}</LeftIconContainer> : null}
      {title}
      {children}
      {hasEssentialsPlan && <span>{t('Upgrade', 'Upgrade')}</span>}
    </SidebarLinkItem>
  )

  return (
    <>
      {internalLink ? (
        <Link href={href} passHref legacyBehavior>
          <LinkComponent />
        </Link>
      ) : (
        <LinkComponent href={onClick ? undefined : href} />
      )}
    </>
  )
}

export default SidebarLinkMobile
